import './HoverableText.scss';
import { useState, useId } from 'react';
import XpektorTooltip from '../XpektorTooltip/XpektorTooltip';

/* eslint-disable react/prop-types */
export default function HoverableText({ text, info, styleClass }) {
  const hoverId = useId();
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div className="hoverable-text-container">
      <p
        className={`${styleClass} ${
          showInfo === true ? 'hover-info-highlight' : ''
        }`}
        onMouseEnter={() => {
          if (info) setShowInfo(true);
        }}
        onMouseLeave={() => setShowInfo(false)}
        data-tooltip-id={hoverId}
      >
        {text}
      </p>
      {info && <XpektorTooltip hoverId={hoverId} content={<p>{info}</p>} />}
    </div>
  );
}
